// Version : 0.0.1
// LastEdit : KARTHEESWARAN
// MODFIED DATE:12-11-2025
//Last ADD : REMOVE COMMENTED LINES

import AttendanceReportActionTypes from './attendance-report.types';

/** ***************** GET ATTENDANCE REPORT DETAILS START *********************** */
export const getAttendanceReportDetailsStart = (getData: any) => ({
	type: AttendanceReportActionTypes.GET_ATTENDANCE_REPORT_LIST_START,
	payload: getData,
});

export const getAttendanceReportDetailsSuccess = (successData: any) => ({
	type: AttendanceReportActionTypes.GET_ATTENDANCE_REPORT_LIST_SUCCESS,
	payload: successData,
});

export const getAttendanceReportDetailsFailure = (failureData: any) => ({
	type: AttendanceReportActionTypes.GET_ATTENDANCE_REPORT_LIST_FAILURE,
	payload: failureData,
});

export const getAttendanceReportDetailsResponseResetStart = () => ({
	type: AttendanceReportActionTypes.GET_ATTENDANCE_REPORT_LIST_RESPONSE_RESET,
});

export const getAttendanceReportDetailsResponseChanged = () => ({
	type: AttendanceReportActionTypes.GET_ATTENDANCE_REPORT_LIST_RESPONSE_CHANGED,
});
/** ***************** GET ATTENDANCE REPORT DETAILS END *********************** */
